import Badge from "iview";

export default Vue => {
  const getBallCV = ball => {
    if (Vue.betType == "ssc" || Vue.betType == "choose5") {
      return { classname: "ball", value: ball };
    }
    if (Vue.betType == "PK10" || Vue.betType == "nn") {
      return { classname: `car c${ball}`, value: "" };
    }
  };
  const pk10Ranks = [
    "冠军",
    "亚军",
    "第三名",
    "第四名",
    "第五名",
    "第六名",
    "第七名",
    "第八名",
    "第九名",
    "第十名"
  ];
  const showType = ["ssc", "choose5"];
  return Vue.showMobile
    ? [
        // {
        //   title: "名次",
        //   width: 100
        //   // key: "rank",
        //   // render: (h, row, i) => {
        //   //   console.log(row.index);
        //   //   // return <span>{pk10Ranks[row.index]}</span>;
        //   //   return <span>{i}</span>;
        //   // }
        // },
        {
          title: "热",
          render: (h, { row }) => {
            return (
              <div>
                {row.hotMap.map((x, i) => (
                  <div class="hot">
                    {Vue.showNum ? <span class="badge">{x.value}</span> : ""}
                    <span class={getBallCV(x.key).classname}>
                      {showType.includes(Vue.betType) ? x.key : ""}
                    </span>
                  </div>
                ))}
              </div>
            );

            // return (
            //   <div>
            //     {Object.keys(row.hot).map((x, i) => (
            //       <div class="hot">
            //         {Vue.showNum ? <span class="badge">{row.hot[x]}</span> : ''}
            //         <span class={getBallCV(x).classname}>{getBallCV(x).value}</span>
            //       </div>
            //     ))}
            //   </div>
            // );
          }
        },
        {
          title: "温",
          render: (h, { row }) => {
            return (
              <div>
                {row.midMap.map((x, i) => (
                  <div class="hot">
                    <span class={getBallCV(x.key).classname}>
                      {showType.includes(Vue.betType) ? x.key : ""}
                    </span>
                  </div>
                ))}
              </div>
            );
            // return (
            //   <span>
            //     {Object.keys(row.warm).map(x => (
            //       <span class={getBallCV(x).classname}>{getBallCV(x).value}</span>
            //     ))}
            //   </span>
            // );
          }
        }
      ]
    : [
        {
          title: "名次",
          width: 100,
          // key: 'rank',
          render: (h, row) => {
            return <span>{pk10Ranks[row.index]}</span>;
          }
        },
        {
          title: "热",
          render: (h, { row }) => {
            return (
              <div>
                {row.hotMap.map((x, i) => (
                  <div class="hot">
                    {Vue.showNum ? <span class="badge">{x.value}</span> : ""}
                    <span class={getBallCV(x.key).classname}>
                      {showType.includes(Vue.betType) ? x.key : ""}
                    </span>
                  </div>
                ))}
              </div>
            );
            // return (
            //   <div>
            //     {Object.keys(row.hot).map((x, i) => (
            //       <div class="hot">
            //         {Vue.showNum ? <span class="badge">{row.hot[x]}</span> : ''}
            //         <span class={getBallCV(x).classname}>{getBallCV(x).value}</span>
            //       </div>
            //     ))}
            //   </div>
            // );
          }
        },
        {
          title: "温",
          render: (h, { row }) => {
            return (
              <div>
                {row.midMap.map((x, i) => (
                  <div class="hot">
                    <span class={getBallCV(x.key).classname}>
                      {showType.includes(Vue.betType) ? x.key : ""}
                    </span>
                  </div>
                ))}
              </div>
            );
            // return (
            //   <span>
            //     {Object.keys(row.warm).map(x => (
            //       <span class={getBallCV(x).classname}>{getBallCV(x).value}</span>
            //     ))}
            //   </span>
            // );
          }
        },
        {
          title: "冷",
          render: (h, { row }) => {
            return (
              <div>
                {row.coldMap.map((x, i) => (
                  <div class="hot">
                    <span class={getBallCV(x.key).classname}>
                      {showType.includes(Vue.betType) ? x.key : ""}
                    </span>
                  </div>
                ))}
              </div>
            );
            // return (
            //   <span>
            //     {Object.keys(row.cold).map(x => (
            //       <span class={getBallCV(x).classname}>{getBallCV(x).value}</span>
            //     ))}
            //   </span>
            // );
          }
        }
      ];
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Lenrefenxi/columns.js